import { Typography, Box } from '@mui/material'
import { useProductPageContext } from '../../contexts/ProductPageContext'
import { ProductItemsFragment } from '../../graphql/ProductItems.gql'

export function ProductBulletpoints({ product }: { product: ProductItemsFragment }) {
  let product_bulletpoint_1
  let product_bulletpoint_2
  let product_bulletpoint_3

  const { configuredVariantBulletpoints } = useProductPageContext()
  if (configuredVariantBulletpoints) {
    product_bulletpoint_1 = configuredVariantBulletpoints.product_bulletpoint_1
    product_bulletpoint_2 = configuredVariantBulletpoints.product_bulletpoint_2
    product_bulletpoint_3 = configuredVariantBulletpoints.product_bulletpoint_3
  } else {
    product_bulletpoint_1 = product.product_bulletpoint_1
    product_bulletpoint_2 = product.product_bulletpoint_2
    product_bulletpoint_3 = product.product_bulletpoint_3
  }

  return (
    <>
      {product_bulletpoint_1 && (
        <Box component='ul' sx={{ paddingLeft: '16px', m: 0 }}>
          {product_bulletpoint_1 && (
            <Typography variant='body2' component='li'>
              {product_bulletpoint_1}
            </Typography>
          )}
          {product_bulletpoint_2 && (
            <Typography variant='body2' component='li'>
              {product_bulletpoint_2}
            </Typography>
          )}
          {product_bulletpoint_3 && (
            <Typography variant='body2' component='li'>
              {product_bulletpoint_3}
            </Typography>
          )}
        </Box>
      )}
    </>
  )
}
